var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"raised-box p-box"},[_c('SimpleForm',{attrs:{"onSubmit":_vm.onSubmit,"fields":[
					{
						label : 'Organisation name',
						name : 'name',
						autocomplete : 'company_name',
						autofocus : true,
						required : true,
						required : !_vm.org.personal,
					},
					{
						name : 'billing_email',
						type : 'email',
						label : 'Billing email',
						required : true,
					} ],"model":_vm.org}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }